function Hero() {
  return (
    <div className="hero__container">
      <div className="hero__box">
      <h1>Sell More!</h1>
      <p className="hero__lead">Open shop on our platform and increase your sales</p>
      <button className="btn">Open your shop</button>
      </div>
    </div>
  );
}

export default Hero;
